export const SIZE_CONFIG = {
  sm: {
    badgeSize: '28px',
    fontSize: 'var(--font-caption1)',
  },
  lg: {
    badgeSize: '40px',
    fontSize: 'var(--font-body2)',
  },
};
